import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

import { Dialog } from '../../../../../components/modal';

class Judges extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        curArea: PropTypes.string,
    };

    /**
     * 插入html
     */

    handleClickRule = () => {
        const { content, curArea } = this.props;

        // console.log(content, curArea);

        if (content && content.some(itme => itme.title === curArea)) {
            Dialog.show({
                title: '评委阵容',
                content: (
                    <img
                        className={styles.judgesImg}
                        src={content.filter(itme => itme.title === curArea)[0].imgUrl}
                        alt=""
                    />
                ),
            });
        } else {
            alert('暂无');
        }
    };

    render() {
        return (
            <div className={styles.other} onClick={this.handleClickRule}>
                美食评委
            </div>
        );
    }
}

const JudgesChip = props => (
    <Chip
        id="230125"
        type="struct"
        title="美食盛典-区域盛典-评委阵容"
        groupName="正文-区域盛典"
        content={props.content}>
        <Judges curArea={props.curArea} />
    </Chip>
);

JudgesChip.propTypes = {
    content: PropTypes.array,
    curArea: PropTypes.string,
};

export default errorBoundary(JudgesChip);
